import {fetchDataFromApi} from './apiHelper';

export const fetchUsersTree = () => fetchDataFromApi('post', '/api/users/tree/get');
export const fetchUsers = () => fetchDataFromApi('post', '/api/users/tree/user/get');

